export default __webpack_public_path__ + "static/media/icon 7.c719927a.svg";